import React from 'react';
import { Box, Typography } from '@mui/material';
import { useEmployeeService, EmployeePositionField, EmployeeTechnologyField } from 'domain/shared/employee';
import { FormFieldsData, FormShowTemplate } from 'framework/form';
import { useShowContext } from 'framework/show';
import { AppIconLabel } from 'framework/ui/mui-builder';
import { TextField } from 'framework/ui/field';
import { IconSectionRow } from 'framework/ui/layout';

const QualificationView: React.FC = () => {
  const { updateSpecializationInfo, getForUpdate } = useEmployeeService();
  const { data: employeeData } = useShowContext();

  if (!employeeData?.alias) {
    return null;
  }

  const handleSubmit = async (values: FormFieldsData): Promise<void | object> => {
    return updateSpecializationInfo(employeeData.alias, values);
  };

  return (
    <Box position="relative">
      <Typography variant="h6" color="primary" mb={2}>
        Qualification
      </Typography>
      <FormShowTemplate
        getDataFunc={() => getForUpdate(employeeData.alias)}
        submitFormFunc={handleSubmit}
        afterSubmit={{
          message: 'Worker information has been successfully updated.',
        }}
        isSmallLoader
      >
        <Box
          sx={{
            '& .field__wrapper': {
              alignItems: 'flex-start',
              '& > div': {
                flexGrow: 0,
              },
            },
          }}
        >
          <IconSectionRow colXl={4} colMd={4} containerProps={{ alignItems: 'flex-start' }}>
            <EmployeePositionField
              source="positionId"
              label={<AppIconLabel icon="specialization" tooltipTitle="Position" />}
            />
            <>
              <EmployeeTechnologyField
                label={<AppIconLabel icon="technology" tooltipTitle="Specialization" />}
                source="specializationInfo.technologyId"
              />
              <Box
                sx={{
                  '.field__wrapper': {
                    ml: '37px',
                  },
                }}
              >
                <EmployeeTechnologyField label="" source="specializationInfo.secondaryTechnologyId" allowEmptySpace />
              </Box>
            </>
            <TextField
              label={<AppIconLabel icon="competencyLevel" tooltipTitle="Competency level" />}
              source="specializationInfo.competencyLevel"
            />
          </IconSectionRow>
        </Box>
      </FormShowTemplate>
    </Box>
  );
};

export default QualificationView;
